@if (items.length) {
    <sirius-container>
        <nav aria-label="Breadcrumb">
            <ol data-cy="breadcrumb-list" [class]="'sir-' + computedVariant">
                @for (item of items; track item.href) {
                    <li class="breadcrumb-item" [attr.data-cy]="'breadcrumb-item-' + $index">
                        @if ($last) {
                            <span aria-current="page" class="is-active" data-cy="breadcrumb-active">
                                {{ item.title }}
                            </span>
                        } @else {
                            <a [siriusLink]="item">{{ item.title }}</a>
                            <sirius-icon
                                name="caret_right_small"
                                aria-hidden="true"
                                class="breadcrumb-separator"></sirius-icon>
                        }
                    </li>
                }
                @if (parentPageLink; as link) {
                    <li class="breadcrumb-back-link" data-cy="breadcrumb-back-link">
                        <a [siriusLink]="link">
                            <sirius-icon name="caret_left_small" aria-hidden="true"></sirius-icon>
                            {{ 'button.backTo' | translate }} {{ link.title }}
                        </a>
                    </li>
                }
            </ol>
        </nav>
    </sirius-container>
}
